import React, { useState, useEffect } from "react";
import Button from "../Button/Button";
import i18n from "../../locales/i18n";
import "./Langtrans.scss";
import { Auth } from "aws-amplify";
import { login } from "../../store/action/index";
import { productData } from "../../store/action/index";
import { useDispatch, useSelector } from "react-redux";
import { langData } from "../../store/action/index";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Modals from "../Modal/Modal";
import { t } from "i18next";

const Langtrans = (props) => {
	const logindata = useSelector((state) => state.login);
	const lang = useSelector((state) => state.language.lang);
	const [success, setsuccess] = useState(false);
	const [openmodal, setopenmodal] = useState(false);
	const [modal, setmodal] = useState(false);
	const [icon, setIcon] = useState(false);
	const location = useLocation();
	const dispatch = useDispatch();
	const history = useHistory();
	const { id } = useParams();
	const changelang = () => {
		i18n.changeLanguage(lang);
		if (lang === "FR") {
			dispatch(
				langData({
					lang: "EN",
				}),
			);
		} else {
			dispatch(
				langData({
					lang: "FR",
				}),
			);
		}
	};

	async function signOut() {
		try {
			await Auth.signOut();
			setsuccess(true);
		} catch (error) {
			const data = error;
		}
	}
	useEffect(() => {
		if (success) {
			localStorage.setItem("email", "");
			history.push("/");
			dispatch(
				login({
					loginStatus: false,
					userDetail: null,
					webflowid: null,
				}),
			);
			dispatch(
				productData({
					step: 0,
					shirt: {},
					designnimg: "",
					color: "",
					price: 0,
					day: 0,
					sales: 0,
					shirtname: "",
					brief: "",
					detail: "",
					campaign: 0,
					shirtdesign: [],
					shirtdesignback: [],
					frontDesignObj: null,
					backDesignObj: null,
					alterImage: null,
				}),
			);
		}
	}, [success]);
	return (
		<div className="lang">
			{props.login &&
				(logindata.loginStatus ? (
					<>
						{location.pathname === "/" ||
						location.pathname === "/design" ||
						location.pathname === "/adminupload" ||
						location.pathname === "/describecampaign" ||
						location.pathname === "/setprice" ||
						location.pathname === "/preview" ||
						location.pathname === `/donepreview/${id}` ? (
							<>
								<span className={props.dashboard ? "log-out2" : "log-out"}>
									<Button
										text={t("dash-board")}
										onClick={() => history.push("/home")}
										style={{ width: "137px" }}
									/>
								</span>
							</>
						) : null}
						<span className={props.dashboard ? "log-out2" : "log-out"}>
							<Button
								text={t("logout")}
								onClick={() => signOut()}
								style={{ width: "140px" }}
							/>
						</span>
					</>
				) : (
					<span className={props.dashboard ? "log-out2" : "log-out"}>
						<Button
							text={t("login")}
							onClick={() => {
								setopenmodal(true);
								setmodal(true);
							}}
						/>
					</span>
				))}
			{props.trans && (
				<Button
					text={lang}
					onClick={() => changelang()}
					className="lang-btn cp"
					style={props.style}
				/>
			)}

			{modal ? (
				<Modals
					condition="login"
					setopenmodal={setopenmodal}
					setIcon={setIcon}
					openmodal={openmodal}
					setmodal={setmodal}
				/>
			) : null}
		</div>
	);
};
export default Langtrans;
